// extracted by mini-css-extract-plugin
export default {"confirmationModal":"confirmationModal_confirmationModal__+oZ2C","modalContent":"confirmationModal_modalContent__cMzkZ","modalTitle":"confirmationModal_modalTitle__L+Wmn"};